enum RouteEndpointsStores {
  BASE_STORES = '/store-management',
  DETAIL_STORE = ':storeId',
  DETAIL_INVOICE_STORE = ':storeId/:invoiceId',
  EDIT_STORE = 'edit/:storeId',
  EDIT_INVOICE_STORE = 'edit/:storeId/:invoiceId',
  ADD_STORE = 'add',
}

export default RouteEndpointsStores;
